<template>
    <div class="staffing home_bg">
      
        <div style="width: 100%;height: 80px;"></div>
        <div class="wx_box">
            <div class="wx_main">
                <div class="top">
                    <div class="wx_title">
                        <span>园区销售管理</span>
                    </div>
                </div>
                <div class="search_top">
                    <div class="search_box">
                        <span class="label">筛选</span>
                        <el-select v-model="tabPage.farm_crop_id" placeholder="品种" size="medium" clearable="">
                            <el-option
                                    v-for="item in crop_list"
                                    :key="item.id"
                                    :label="item.crop_name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
						<el-select v-model="tabPage.sale_channel_id" placeholder="销售渠道" size="medium" clearable="">
						    <el-option
						            v-for="item in channel_list"
						            :key="item.id"
						            :label="item.name"
						            :value="item.id">
						    </el-option>
						</el-select>
                        
						<span class="label"></span>
						<el-button type="primary" @click="search()">搜索</el-button>
                    </div>
                    <div class="btns">
                        <el-button class="addBtn" @click="editSaleShow = true">添加销售明细</el-button>
						 <el-button class="addBtn" @click="return_farm()" style="display: none;">返回当前园区</el-button>
                    </div>
                </div>
                <el-table :data="tableData" class="wx_table" :row-class-name="tableRowClassName">
                  <el-table-column prop="farm_crop_name" label="品种"></el-table-column>
                  <el-table-column prop="sale_unit_price" label="销售单价(元/斤)"></el-table-column>
                  <el-table-column prop="sale_number" label="销售数量(斤)"></el-table-column>
                  <el-table-column prop="total_price" label="总价(元)">
				  <template slot-scope="scope">
				          {{(scope.row.sale_number*scope.row.sale_unit_price).toFixed(2)}}
				  </template>
				  </el-table-column>
				  <el-table-column prop="sale_channel_name" label="渠道名称"></el-table-column>
				   <el-table-column prop="remark" label="备注"></el-table-column>
				   <el-table-column prop="created_at" label="记录时间"></el-table-column>
                  
                    <el-table-column label="操作" width="460">
                        <template slot-scope="scope">
                            <el-button class="edit_btn" type="primary" plain size="small" @click="editSale(scope.row)">编辑</el-button>
                            <el-button class="del_btn" type="danger" plain size="small" @click="deleteData(scope.row.id,1)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination v-show="total>0"  @size-change="handleSizeChange" @current-change="handleCurrentChange"     :current-page="tabPage.currentPage" :page-size="tabPage.pagesize"  :total="total"   layout="total, sizes, prev, pager, next, jumper"></el-pagination>
  
				</div>
                <div class="tip_box">
                    <h5>按品种汇总({{crop_total.toFixed(2)}}元)：</h5>
					   <el-table :data="tableCropData" class="wx_table" :row-class-name="tableRowClassName">
						    <el-table-column prop="farm_crop_name" label="品种"></el-table-column>
							<el-table-column prop="total_price" label="总价（元）"></el-table-column>
							<el-table-column prop="total_number" label="销售数量（斤）"></el-table-column>
							<el-table-column prop="average_price" label="平均价格"></el-table-column>
						    </el-table>
                  
                </div>
				<div class="tip_box">
				    <h5>按渠道汇总({{channel_total.toFixed(2)}}元)：</h5>
					   <el-table :data="tableChannelData" class="wx_table" :row-class-name="tableRowClassName" >
						    <el-table-column prop="sale_channel_name" label="渠道"></el-table-column>
							<el-table-column prop="total_price" label="销售总价（元）"></el-table-column>
							<el-table-column prop="total_number" label="销售总量（斤）"></el-table-column>
							<el-table-column prop="average_price" label="平均价格"></el-table-column>
						    </el-table>
				  
				</div>
            </div>
        </div>
        <!--编辑/添加人员弹窗-->
      <WxMessageBox :show="editSaleShow" @save="editSaleSave" @canse="editSaleCanse">
      	
          <div slot="content">
      		 <el-form :model="saleForm" :rules="saleRules" ref="saleForm" label-width="0px">
              <div class="wx_form">
      			
                 
      			<div class="form_item">
      			    <span class="label">品种列表</span>
      			    <div class="input">
      			      	<el-form-item label="" prop="farm_crop_id">
      			        <el-select v-model="saleForm.farm_crop_id" placeholder="请选择" size="mini">
      			            <el-option
      			                    v-for="item in crop_list"
      			                    :key="item.id"
      			                    :label="item.crop_name"
      			                    :value="item.id">
      			            </el-option>
      			        </el-select>
      			      	</el-form-item>
      			    </div>
      			</div>
				<div class="form_item">
				    <span class="label">单价(元/斤)</span>
				    <div class="input">
				      					 <el-form-item label="" prop="sale_unit_price">
				        <el-input v-model="saleForm.sale_unit_price" size="mini" ></el-input>
				      					</el-form-item>
				    </div>
				</div>
				<div class="form_item">
				    <span class="label">销量(斤)</span>
				    <div class="input">
				      					 <el-form-item label="" prop="sale_number">
				        <el-input v-model="saleForm.sale_number" size="mini" ></el-input>
				      					</el-form-item>
				    </div>
				</div>
				<div class="form_item">
				    <span class="label">渠道</span>
				    <div class="input">
				      	<el-form-item label="" prop="sale_channel_id">
				        <el-select v-model="saleForm.sale_channel_id" placeholder="请选择" size="mini">
				            <el-option
				                    v-for="item in channel_list"
				                    :key="item.id"
				                    :label="item.name"
				                    :value="item.id">
				            </el-option>
				        </el-select>
				      					</el-form-item>
				    </div>
				</div>
      	
               
                 <div class="form_item">
                     <span class="label">备注</span>
                     <div class="input">
                       					 <el-form-item label="" prop="remark">
                         <el-input v-model="saleForm.remark" size="mini"  type="areatext"></el-input>
                       					</el-form-item>
                     </div>
                 </div>
                
      
              
				  
				 
              </div>
      		</el-form>
          </div>
      	
      </WxMessageBox>
        <!--点击删除弹窗-->
        <WxMessageBox :show="delShow" @save="delSave" @canse="delCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定删除此项，删除后，</p>
                    <p>将不可恢复！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--点击确认弹窗-->
        <WxMessageBox :show="saveShow" @save="saveSave" @canse="saveCanse">
            <div slot="content">
                <div class="word">
                    <p>你是否确定本次操作！</p>
                </div>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
	import {getFarmSaleRecord,createFarmSaleRecord,deleteFarmSaleRecord} from '@/api/sale'
	 import axios from 'axios';
    import Header from '@/components/Header';
    import OpenSteps from '@/components/OpenSteps';
    import WxMessageBox from '@/components/MessageBox';
	import {
		getFarmInfo
	} from '@/api/api'
    export default {
        name: "sale",
        data(){
            return{
                total:0,  
				tableData: [],
				crop_list:[],
				channel_list:[],
                tabPage:{
					farm_crop_id:'',
					sale_channel_id:'',
					currentPage:1,
                    pagesize:10,    // 每页的数据
                },
				crop_total:0,
				channel_total:0,
                editSaleShow:false,
                delShow:false,
                saveShow:false,
				tableChannelData:[],
				tableCropData:[],

				saleForm:{ 
					       id:'',
					       farm_crop_id:'',
						   sale_channel_id:'',
						   sale_unit_price:'',
						   sale_number:'',
						   remark:'',   
				},
				saleRules: {					
					
				    farm_crop_id: [{required: true,message: '请选择园区农作物',trigger: 'change'}
							  ],
					 sale_channel_id: [{required: true,message: '请选择销售渠道',trigger: 'change'}
					 		],
				
					sale_unit_price: [{required: true,message: '请输入销售单价',trigger: 'blur'}
							       ],
					sale_number: [{required: true,message: '请输入销售数量',trigger: 'blur'}
							],	
					remark: [{required: true,message: '请输入销售备注',trigger: 'blur'}
							],							
				},
            }
        },
		mounted() {
			this.farm_id=this.$route.params.id,
			getFarmInfo(this.$route.params.id).then(resp => {
			
			
				if(resp.farm.is_check==1){
					this.get_farm_sale_record()
				}else{
					this.$message.error("请先完善农事管理板块相关申请工作，才能开通此板块！")
					this.$router.push("/park/detail/"+this.$route.params.id)
				}
				})
			
		},
        methods:{
			get_farm_sale_record() {
				getFarmSaleRecord(this.farm_id,this.tabPage,1).then(resp => {
					 this.tableData=resp.list					
					 this.total = resp.total;
					 this.crop_list=resp.crop_list
					 this.channel_list=resp.channel_list
					 this.tableChannelData=resp.channel_tongji_list
					 this.tableCropData=resp.crop_tongji_list
					 this.crop_total=resp.crop_total
					 this.channel_total=resp.channel_total
				})
			},
            // 表格斑马纹
            tableRowClassName({row, rowIndex}) {
                if (rowIndex % 2 !== 1) {
                    return 'single-row';
                }else{
                    return 'double-row';
                }
            },
            // 分页
            handleSizeChange: function (size) {
                this.tabPage.pagesize = size;
				this.get_farm_sale_record()
				
            },
            handleCurrentChange: function(currentPage){
                this.tabPage.currentPage = currentPage;
				 this.get_farm_sale_record()
				
            },
			
			editSale(row){
				this.saleForm["id"]=row.id
				this.saleForm["farm_crop_id"]=row.farm_crop_id
				this.saleForm["sale_channel_id"]=row.sale_channel_id,
				this.saleForm["sale_unit_price"]=row.sale_unit_price,
				this.saleForm["sale_number"]=row.sale_number
				this.saleForm["remark"]=row.remark
			
				 this.editSaleShow=true
			},
			return_farm(){
				this.$router.push("/park/detail/"+this.farm_id)
			},

			search(){
				  this.get_farm_sale_record()
			},
            // 编辑/添加人员弹窗确认
            editSaleSave(){
               this.$refs["saleForm"].validate((valid) => {
               	if (valid) {             
               		 createFarmSaleRecord(this.farm_id,this.saleForm).then(resp=>{					
                          this.$message.success("添加成功");
               			  this.get_farm_sale_record()
               			  this.editSaleShow = false	
               			  this.$refs["saleForm"].resetFields()							
               			}).catch(error=>console.log(error))
               	} else {
               		console.log('error submit!!');
               		return false;
               	}
               });
            },
			clearSaleForm(){
				this.saleForm={ 
					       id:'',
					       farm_crop_id:'',
						   sale_channel_id:'',
						   sale_unit_price:'',
						   sale_number:'',
						   remark:'',   
				}
			},
			deleteData(id){
				this.delete_id=id;
				this.delShow=true
			},
            // 编辑/添加人员弹窗取消
            editSaleCanse(){
                this.editSaleShow = false
				this.clearSaleForm()
            },
            // 点击删除弹窗确定
            delSave(){
                this.delShow = false
                this.$nextTick(()=>{
                    this.saveShow = true
                })
            },
            // 点击删除弹窗取消
            delCanse(){
                this.delShow = false
            },
            // 点击确认弹窗
          // 点击确认弹窗
          saveSave(){
          deleteFarmSaleRecord(this.delete_id).then(resp=>{
          		 this.saveShow = false
          	 this.get_farm_sale_record()
          	
          })
              
          },
            // 点击确认弹窗
            saveCanse(){
                this.saveShow = false
            },
		
        },
        components: {
            WxMessageBox
        }
    }
</script>

<style lang="less">
    .staffing{
        .wx_box{
            .wx_main {
                background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                background-size: cover;
                padding: 11px 35px 50px 24px;
                .top {
                    overflow: hidden;
                }
                .search_top{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 30px;
                    .label{
                        font-size: 14px;
                        font-weight: 400;
                        color: #D0D0D0;
                        padding-right: 10px;
                    }
                    .el-input{
                        width: 160px;
                    }
                    .el-select{
                        width: 160px;
                        margin-right: 14px;
                    }
                    .input-with-select{
                        width: 250px;
                        margin-left: 14px;
                        .el-input-group__append, .el-input-group__prepend{
                            background: rgba(45, 153, 255, 0.3);
                        }
                    }
                    .btns{
                        .addBtn{
                            border: 1px solid #2D99FF;
                            background-color: transparent;
                            font-size: 18px;
                            font-weight: 400;
                            color: #2D99FF;
                            padding: 7px 18px;
                            border-radius: 0;
                        }
                    }
                }
                .wx_table{
                    margin-top: 25px;
                    .cell{
                        img{
                            width: 66px;
                            height: 36px;
                        }
                    }
                    .msg{
                        display: flex;
                        justify-content: center;
                        div{
                            &+div{
                                margin-left: 20px;
                            }
                            p{
                                font-size: 12px;
                                font-weight: 500;
                                color: #C7D7DE;
                                line-height: 17px;
                            }
                        }
                    }
                }
                .tip_box{
                    padding-top: 17px;
                    h5{
                        font-size: 18px;
                        font-weight: 500;
                        color: #C7D7DE;
                        line-height: 30px;
                    }
                    p{
                        font-size: 18px;
                        font-weight: 500;
                        color: #C7D7DE;
                        line-height: 30px;
                    }
                }
            }
        }
    }
</style>
